var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',_vm._l((_vm.prints),function(print,index){return _c('v-list-tile',{key:index},[_c('v-list-tile-content',[_vm._v("\n      "+_vm._s(print.user.firstName)+" "+_vm._s(print.user.lastName)+"\n    ")]),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v("\n      "+_vm._s(_vm.formatDate(print.createdAt))+"\n    ")])],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }